module.exports = __webpack_public_path__ + "static/media/signal-stream.c7ef8303.svg";